<template lang="pug">
.promo-footer-social
  .promo-footer-social__wrap
    .promo-footer-social__title {{ $t("footer.social") }}
    SocialIconsList
</template>

<script>
import SocialIconsList from "@battle_teams_2_components/components/social-icons-list/vue/SocialIconsList";

export default {
  name: "SocialBlock",
  components: {
    SocialIconsList,
  },
}
</script>

<style lang="scss" scoped>
@import "../../styles/promo-footer-social";
</style>
